export default __webpack_public_path__ + "static/media/Seiren_Logo_114px.758ee03d.svg";